import { useMemo } from 'react';

import { EventCard } from 'hb-react/shared/apps/Events/components/EventCard';
import type { Event } from 'hb-react/shared/apps/Events/components/EventCard/types';
import type { IndexEventProps } from 'hb-react/shared/apps/Events/components/EventsIndexContainer/components/types';

const EventCardV2 = (props: {
  event: IndexEventProps;
  onClick?: (event: Event) => void;
}) => {
  const { event, onClick } = props;

  const eventCardProps = useMemo(
    () =>
      ({
        attendanceMode: event.attendance_mode,
        cancelled: event.cancelled,
        coverPicture: event.new_cover_picture.medium_url,
        displayEventCreator: true,
        displayPriceTag: event.display_price_tag,
        endDate: event.end_date,
        hasAttendees: event.has_attendees,
        id: event.id,
        networkCategories: event.network_categories,
        participationType: 'tickets',
        startDate: event.start_date,
        ticketsDueDate: '',
        timezone: event.timezone,
        title: event.title,
        type: event.type,
        webinarUrl: event.webinar_url,
        zoomMeetingId: undefined,
        parent: {
          parentId: 99999,
          parentType: 'Network',
          name: event.organizer.name,
          avatarUrl: event.organizer_logo_url,
        },
        location: {
          address: event.locations?.address || event.location?.address,
        },
      }) satisfies Event,
    [event],
  );

  return <EventCard event={eventCardProps} onClick={onClick} />;
};

export default EventCardV2;
